<app-spinner *ngIf="isLoading"></app-spinner>

<div *ngIf="!isLoading" class="col col-md-4 col-sm-8 col-xs-12">
  <div class="card">
    <div class="card-header">Iniciar sesión</div>
    <div class="card-body">
      <form (submit)="onSubmit(loginForm)" #loginForm="ngForm">
        <ngb-alert [type]="'danger'" *ngIf="errorMessage">
          {{ errorMessage }}
        </ngb-alert>
        <div class="mb-3">
          <label class="form-label">E-mail:</label>
          <input
            type="email"
            class="form-control"
            name="email"
            id="email"
            ngModel
            #emailInput="ngModel"
            required
            email
          />
          <span
            class="text-danger"
            *ngIf="!emailInput.pristine && emailInput.invalid"
            >Por favor, introduzca una dirección de e-mail válida.</span
          >
        </div>
        <div class="mb-3">
          <label class="form-label">Contraseña:</label>
          <input
            type="password"
            class="form-control"
            name="password"
            id="password"
            ngModel
            #passwordInput="ngModel"
            required
          />
          <span
            class="text-danger"
            *ngIf="!passwordInput.pristine && passwordInput.invalid"
            >Por favor, introduzca una contraseña válida.</span
          >
        </div>
        <button
          *ngIf="!isLoading"
          type="submit"
          id="submitBtn"
          class="btn btn-primary"
        >
          Iniciar sesión
        </button>
        <hr />
        <!-- Deshabilitar registro
        <a routerLink="/registro">Registrarse</a>-->
      </form>
    </div>
  </div>
</div>
